import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'

const store = CreateGenericSlice<
  DeviceModeInterface,
  SliceCaseReducers<DeviceModeInterface>
>({
  name: 'Device',
  initialState: {
    Desktop: false,
    Laptop: false,
    Mobile: false,
    Tablet: false,
  },
  reducers: {
    $watched: (state, { payload }) => {
      state[payload?.type] = true
      Object.getOwnPropertyNames(state)
        .filter((n) => n != payload?.type)
        .map((n) => {
          state[n] = false
        })
    },
  },
})

export const { $watched } = store.actions

export default store.reducer
